<div class="layout-wrapper">
  <app-sidebar></app-sidebar>
  <app-header></app-header>
  <div class="layout-main ml-7 surface-ground min-h-screen p-4 pr-3 border-round-left-2xl ">
    <router-outlet></router-outlet>
  </div>
</div>